export const tools_cadastro_cliente = [
    {
        type: "function",
        function: {
            name: "createNewClient",
            description: "Register a new customer in the system or update a customer. If the user provides Name, Document (CPF/CNPJ) and Phone, assume the intention is to REGISTER the client and execute this tool immediately.",
            parameters: {
                type: "object",
                properties: {
                    data: {
                        type: "object",
                        properties: {
                            client_id: {
                                type: ["string", "null"],
                                description: "Provide only when updating an previous registered customer. Must be null when creating a new customer. This field is exclusively for explicit and unambiguous update actions"
                            },
                            name: {
                                type: "string",
                                description: "Full name of the customer (required)"
                            },
                            document: {
                                type: "string",
                                pattern: "^[0-9]{11}$|^[0-9]{14}$",
                                description: "CPF (11 digits) or CNPJ (14 digits), numbers only"
                            },
                            phone: {
                                type: "string",
                                description: "Main phone number. You MUST extract only the digits (10 or 11) from the input, removing any parentheses, dashes, or spaces."
                            },
                            email: {
                                type: ["string", "null"],
                                description: "Valid email or null. DO NOT ask the user for this information if not provided."
                            },
                            birthdate: {
                                type: ["string", "null"],
                                description: "Date of birth in the format YYYY-MM-DD or null. DO NOT ask the user for this information if not provided."
                            },
                            address: {
                                type: ["object", "null"],
                                properties: {
                                    zip_code: {
                                        type: ["string", "null"] },
                                    street: {
                                        type: ["string", "null"] },
                                    number: {
                                        type: ["string", "null"] },
                                    complement: {
                                        type: ["string", "null"] },
                                    neighborhood: {
                                        type: ["string", "null"] },
                                    city: {
                                        type: ["string", "null"] },
                                    state: {
                                        type: ["string", "null"] }
                                },
                                description: "Full address or null if any required part is missing. DO NOT ask the user for this information if not provided."
                            }
                        },
                        required: ["name", "document", "phone"]
                    },

                },
                required: ["data"],
                additionalProperties: false

            },
        },
    }
];
